import { PackageCheck } from "lucide-react";
import { useAuth } from "../auth/AuthProvider";
import { Button } from "../../shared/ui/Button";
import { Card, EmptyState } from "../../shared/ui/Card";
import { StatusBadge } from "../../shared/ui/Status";
import { useShop, useShopActions } from "./useShop";
export function ShopFulfillmentPanel() {
  const { session } = useAuth();
  const query = useShop(),
    actions = useShopActions();
  if (!query.data) return null;
  const orders = query.data.orders.filter(
    (x) =>
      x.status === "pending_fulfillment" &&
      (session?.profile.role === "super" ||
        x.storeId === session?.profile.storeId),
  );
  return (
    <section className="shop-panel">
      <div className="section-divider">
        <span>商城履约</span>
        <h2>兑换商品发放</h2>
      </div>
      {orders.length ? (
        <div className="approval-list">
          {orders.map((o) => (
            <Card key={o.id}>
              <div className="approval-order">
                <PackageCheck />
                <div>
                  <span>{o.orderNumber}</span>
                  <h2>{o.productName}</h2>
                  <p>
                    {o.receiverName} · {o.receiverPhone} · 消耗{o.points}星能
                  </p>
                </div>
                <StatusBadge tone="warning">待发放</StatusBadge>
              </div>
              <div className="approval-actions">
                <Button
                  onClick={() =>
                    window.confirm("确认商品已经交付给领取人？") &&
                    actions.fulfill(o.id)
                  }
                  disabled={actions.pending}
                >
                  <PackageCheck size={15} />
                  确认已发放
                </Button>
              </div>
            </Card>
          ))}
        </div>
      ) : (
        <EmptyState
          title="暂无待发放商品"
          description="员工完成星能兑换后会进入本店履约清单。"
        />
      )}
    </section>
  );
}
